import { EMPTY, Observable, switchMap } from "rxjs";

export function walk$<T,O>(f:(value:T)=>Observable<O>|Promise<O>){
	const x=switchMap(
		(input:T):(Observable<O>|Promise<O>)=>{
			if(!input)
				return <Observable<O>>EMPTY;
			return f(input);
		}
	);
	return x;
}
